import { z } from 'zod';
/*
  Standard error response schema used across all API endpoints
*/
export const errorResponseSchema = z.object({
    error: z.string(),
    message: z.string(),
    /*
      Machine-readable domain code from `createError(...)` — e.g.
      `INVITE_IDENTITY_UNVERIFIED`. The backend error handler already sends this
      (see middleware/error-handler.ts), but omitting it here made
      fast-json-stringify strip it from every response, so clients only ever saw
      the human `message` and the generic Fastify name in `error` (e.g.
      "Forbidden"). Declared optional: the 500 fallback path sends no code, and
      older clients ignore the extra field.
    */
    code: z.string().optional(),
});
/*
  Validation error response schema for 400 Bad Request
*/
export const validationErrorResponseSchema = errorResponseSchema.extend({
    details: z
        .array(z.object({
        field: z.string(),
        message: z.string(),
    }))
        .optional(),
});
//# sourceMappingURL=errors.js.map